import { useNavigate } from 'react-router-dom';
import './Legal.css';

const LAST_UPDATED = '26 aprile 2025';
const EFFECTIVE_DATE = '26 aprile 2025';
const CONTACT_EMAIL = 'alex.siroli@gmail.com';
const APP_NAME = 'Chain Reaction';
const DEVELOPER_NAME = 'Alex Siroli';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <button className="legal-header__back" onClick={() => navigate(-1)}>
          ← Indietro
        </button>
        <h1 className="legal-header__title">Termini di Servizio</h1>
        <button className="legal-header__sibling-link" onClick={() => navigate('/privacy')}>
          Privacy Policy →
        </button>
      </header>

      {/* Content */}
      <main className="legal-content">
        {/* Hero */}
        <div className="legal-hero">
          <div className="legal-badge">📜 Termini & Condizioni</div>
          <h2 className="legal-hero__title">Termini di Servizio</h2>
          <p className="legal-hero__meta">
            <span>📅 Ultimo aggiornamento: {LAST_UPDATED}</span>
            <span>✅ In vigore dal: {EFFECTIVE_DATE}</span>
          </p>
        </div>

        {/* Intro */}
        <div className="legal-section">
          <div className="legal-highlight legal-highlight--info">
            <p>
              <strong>Versione semplice:</strong> Usa {APP_NAME} in modo corretto e rispettoso.
              L'app è gratuita, non ha pubblicità e rispetta la tua privacy. Continuando a usarla
              accetti questi termini.
            </p>
          </div>
          <p>
            I presenti Termini di Servizio ("<strong>Termini</strong>") disciplinano l'utilizzo
            dell'applicazione {APP_NAME} (la "<strong>App</strong>"), sviluppata e gestita da{' '}
            <strong>{DEVELOPER_NAME}</strong> ("<strong>noi</strong>"). Utilizzando l'App, dichiari
            di aver letto, compreso e accettato i presenti Termini nella loro interezza. Se non
            accetti i Termini, ti preghiamo di non utilizzare l'App.
          </p>
        </div>

        {/* 1 — Il Servizio */}
        <div className="legal-section">
          <h3 className="legal-section__title">1. Descrizione del Servizio</h3>
          <p>
            {APP_NAME} è un gioco di intesa e comunicazione verbale per gruppi. Il servizio
            comprende:
          </p>
          <ul>
            <li>
              Modalità di gioco <strong>Locale</strong> (un dispositivo, più giocatori fisicamente
              presenti)
            </li>
            <li>
              Modalità <strong>Multiplayer</strong> (più dispositivi collegati in remoto tramite
              stanze di gioco)
            </li>
            <li>
              Funzionalità di <strong>Statistiche</strong> e storico partite associate all'account
              utente
            </li>
            <li>
              Funzionalità di <strong>Squadre</strong> per organizzare gruppi di gioco ricorrenti
            </li>
            <li>Eventuali ulteriori funzionalità future indicate in-app</li>
          </ul>
          <p>
            Il servizio è fornito <strong>gratuitamente</strong>, senza pubblicità e senza acquisti
            in-app. Ci riserviamo il diritto di modificare, sospendere o interrompere il servizio in
            qualsiasi momento, con o senza preavviso, senza che ciò faccia sorgere alcun diritto di
            risarcimento.
          </p>
        </div>

        {/* 2 — Account */}
        <div className="legal-section">
          <h3 className="legal-section__title">2. Account e Registrazione</h3>
          <p>
            Alcune funzionalità (Multiplayer, Statistiche, Squadre) richiedono un account. La
            registrazione avviene tramite autenticazione <strong>Google OAuth 2.0</strong>
            (Firebase Authentication). Accettando i Termini:
          </p>
          <ul>
            <li>Dichiari che le informazioni fornite tramite Google sono accurate e aggiornate.</li>
            <li>Sei responsabile di mantenere riservate le credenziali del tuo account Google.</li>
            <li>Sei responsabile di tutte le attività svolte tramite il tuo account.</li>
            <li>
              Se sospetti un accesso non autorizzato, devi notificarcelo immediatamente a{' '}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </li>
          </ul>
          <div className="legal-highlight legal-highlight--warn">
            <p>
              <strong>Età minima:</strong> devi avere almeno <strong>13 anni</strong> per creare un
              account. Se hai meno di 16 anni, è richiesto il consenso di un genitore o tutore.
            </p>
          </div>
        </div>

        {/* 3 — Regole di Utilizzo */}
        <div className="legal-section">
          <h3 className="legal-section__title">3. Regole di Utilizzo Accettabile</h3>
          <p>
            Utilizzando l'App, accetti di <strong>non</strong>:
          </p>
          <ul>
            <li>Usare l'App per scopi illegali o fraudolenti.</li>
            <li>
              Tentare di accedere a dati di altri utenti o ai sistemi backend non autorizzati.
            </li>
            <li>
              Effettuare reverse engineering, decompilare o modificare l'App senza autorizzazione
              scritta.
            </li>
            <li>
              Usare bot, script automatizzati o qualsiasi strumento che simuli l'attività umana.
            </li>
            <li>
              Interferire con il normale funzionamento dei server o delle reti collegate all'App.
            </li>
            <li>
              Caricare o trasmettere contenuti offensivi, discriminatori, illegali o che violino
              diritti di terzi.
            </li>
            <li>
              Usare l'App per molestare altri utenti o raccogliere dati personali di terzi senza
              consenso.
            </li>
          </ul>
          <p>
            La violazione di queste regole può comportare la sospensione o la cancellazione
            immediata dell'account, senza diritto di rimborso o compensazione.
          </p>
        </div>

        {/* 4 — Proprietà Intellettuale */}
        <div className="legal-section">
          <h3 className="legal-section__title">4. Proprietà Intellettuale</h3>
          <p>
            Tutti i diritti sull'App, inclusi ma non limitati a codice sorgente, grafica, loghi,
            design, testi, suoni e parole del gioco, sono di proprietà esclusiva di{' '}
            <strong>{DEVELOPER_NAME}</strong> o dei rispettivi licenzianti.
          </p>
          <p>
            Ti viene concessa una{' '}
            <strong>licenza limitata, non esclusiva, non trasferibile e revocabile</strong> per
            utilizzare l'App a fini personali e non commerciali, nel rispetto dei presenti Termini.
          </p>
          <p>
            È vietata qualsiasi riproduzione, distribuzione, modifica o creazione di opere derivate
            senza previa autorizzazione scritta.
          </p>
        </div>

        {/* 5 — Contenuto Utente */}
        <div className="legal-section">
          <h3 className="legal-section__title">5. Contenuto Generato dall'Utente</h3>
          <p>
            L'App può consentire agli utenti con privilegi amministrativi di caricare parole o frasi
            di gioco. Per qualsiasi contenuto da te caricato:
          </p>
          <ul>
            <li>Dichiari di essere l'autore o di avere il diritto di utilizzarlo.</li>
            <li>
              Concedi a {DEVELOPER_NAME} una licenza mondiale, gratuita, non esclusiva per
              utilizzare, riprodurre e mostrare tale contenuto esclusivamente ai fini del
              funzionamento dell'App.
            </li>
            <li>
              Sei l'unico responsabile dei contenuti caricati. Non ti è consentito caricare
              contenuti che violino leggi vigenti, diritti di terzi o che siano osceni, offensivi o
              discriminatori.
            </li>
          </ul>
          <p>
            Ci riserviamo il diritto di rimuovere qualsiasi contenuto che, a nostra discrezione,
            violi i presenti Termini o risulti inappropriato, senza obbligo di preavviso.
          </p>
        </div>

        {/* 6 — Privacy */}
        <div className="legal-section">
          <h3 className="legal-section__title">6. Privacy e Protezione dei Dati</h3>
          <p>
            Il trattamento dei tuoi dati personali è disciplinato dalla nostra{' '}
            <button
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-primary)',
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                fontFamily: 'inherit',
                fontSize: 'inherit',
                padding: 0,
              }}
              onClick={() => navigate('/privacy')}
            >
              Informativa sulla Privacy
            </button>
            , che costituisce parte integrante dei presenti Termini. Ti invitiamo a leggerla
            attentamente prima di utilizzare l'App.
          </p>
        </div>

        {/* 7 — Esclusione di Garanzie */}
        <div className="legal-section">
          <h3 className="legal-section__title">7. Esclusione di Garanzie</h3>
          <p>
            L'App è fornita "<strong>così com'è</strong>" (<em>as-is</em>) e "
            <strong>come disponibile</strong>" (<em>as-available</em>), senza garanzie di alcun
            tipo, esplicite o implicite, incluse, senza limitazione, le garanzie di commerciabilità,
            idoneità a uno scopo specifico e non violazione.
          </p>
          <p>Non garantiamo che:</p>
          <ul>
            <li>L'App sia priva di errori o interruzioni.</li>
            <li>I risultati ottenuti tramite l'App siano accurati o affidabili.</li>
            <li>Qualsiasi difetto sarà corretto entro un termine specifico.</li>
          </ul>
        </div>

        {/* 8 — Limitazione di Responsabilità */}
        <div className="legal-section">
          <h3 className="legal-section__title">8. Limitazione di Responsabilità</h3>
          <p>
            Nei limiti consentiti dalla legge applicabile, {DEVELOPER_NAME} non sarà responsabile
            per danni indiretti, incidentali, speciali, consequenziali o punitivi, inclusi la
            perdita di dati, il lucro cessante o l'interruzione dell'attività, derivanti dall'uso o
            dall'impossibilità di usare l'App, anche se avvisata della possibilità di tali danni.
          </p>
          <p>
            La responsabilità complessiva di {DEVELOPER_NAME} nei tuoi confronti non supererà, in
            nessun caso, l'importo di <strong>€ 10,00</strong> (dieci euro), trattandosi di un
            servizio gratuito.
          </p>
        </div>

        {/* 9 — Terze Parti */}
        <div className="legal-section">
          <h3 className="legal-section__title">9. Servizi di Terze Parti</h3>
          <p>
            L'App si avvale di servizi di terze parti (Google Firebase, Netlify). L'uso di tali
            servizi è soggetto ai rispettivi termini e condizioni. Non siamo responsabili per la
            disponibilità, l'accuratezza o il comportamento di tali servizi.
          </p>
          <p>
            L'App potrebbe contenere link a siti web di terze parti. Questi link sono forniti per
            comodità e non implicano approvazione del contenuto di tali siti.
          </p>
        </div>

        {/* 10 — Modifiche ai Termini */}
        <div className="legal-section">
          <h3 className="legal-section__title">10. Modifiche ai Termini</h3>
          <p>
            Ci riserviamo il diritto di modificare i presenti Termini in qualsiasi momento. In caso
            di modifiche sostanziali ti avviseremo tramite notifica in-app o via e-mail almeno{' '}
            <strong>15 giorni prima</strong> dell'entrata in vigore. La versione sempre aggiornata è
            disponibile nella sezione <strong>/terms</strong> dell'App.
          </p>
          <p>
            L'uso continuato dell'App dopo l'entrata in vigore delle modifiche costituisce
            accettazione dei nuovi Termini. Se non accetti le modifiche, puoi cessare di utilizzare
            l'App e richiedere la cancellazione del tuo account.
          </p>
        </div>

        {/* 11 — Risoluzione e Cancellazione */}
        <div className="legal-section">
          <h3 className="legal-section__title">11. Risoluzione e Cancellazione dell'Account</h3>
          <p>
            Puoi cessare di utilizzare l'App e richiedere la cancellazione del tuo account in
            qualsiasi momento scrivendo a <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <p>
            Ci riserviamo il diritto di sospendere o cancellare il tuo account in caso di violazione
            dei presenti Termini, senza obbligo di preavviso e senza responsabilità.
          </p>
          <p>
            Alla cancellazione dell'account, tutti i tuoi dati personali (statistiche, profilo)
            saranno eliminati dai nostri sistemi entro 30 giorni, come descritto nell'Informativa
            sulla Privacy.
          </p>
        </div>

        {/* 12 — Legge Applicabile */}
        <div className="legal-section">
          <h3 className="legal-section__title">
            12. Legge Applicabile e Risoluzione delle Controversie
          </h3>
          <p>
            I presenti Termini sono disciplinati dalla <strong>legge italiana</strong>. Qualsiasi
            controversia derivante dai Termini o dall'utilizzo dell'App sarà di competenza esclusiva
            del <strong>Foro di Bologna</strong>, Italia, salvo diverso accordo scritto tra le
            parti.
          </p>
          <p>
            Prima di ricorrere ad azioni legali, le parti si impegnano a tentare in buona fede una
            risoluzione amichevole della controversia entro 30 giorni dalla notifica scritta.
          </p>
        </div>

        {/* 13 — Disposizioni Generali */}
        <div className="legal-section">
          <h3 className="legal-section__title">13. Disposizioni Generali</h3>
          <ul>
            <li>
              <strong>Intero accordo:</strong> I presenti Termini, unitamente all'Informativa sulla
              Privacy, costituiscono l'intero accordo tra te e {DEVELOPER_NAME} in relazione
              all'App.
            </li>
            <li>
              <strong>Separabilità:</strong> Se una disposizione dei Termini è ritenuta invalida o
              inapplicabile, le restanti disposizioni rimangono in pieno vigore ed effetto.
            </li>
            <li>
              <strong>Rinuncia:</strong> Il mancato esercizio di un diritto da parte nostra non
              costituisce rinuncia a tale diritto.
            </li>
            <li>
              <strong>Cessione:</strong> Non puoi cedere i tuoi diritti o obblighi derivanti dai
              Termini senza il nostro previo consenso scritto.
            </li>
          </ul>
        </div>

        {/* 14 — Contatti */}
        <div className="legal-section">
          <h3 className="legal-section__title">14. Contatti</h3>
          <p>Per qualsiasi domanda relativa ai presenti Termini di Servizio:</p>
          <div className="legal-highlight">
            <p>
              📧 <strong>E-mail:</strong> <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              <br />
              🏢 <strong>Titolare:</strong> {DEVELOPER_NAME}
              <br />
              🌐 <strong>App:</strong> {APP_NAME}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="legal-footer">
          <p>
            © {new Date().getFullYear()} {DEVELOPER_NAME} — {APP_NAME}
          </p>
          <p>Versione documento: 1.0 — {EFFECTIVE_DATE}</p>
          <div className="legal-footer__links">
            <button onClick={() => navigate('/privacy')}>Privacy Policy</button>
            <a href={`mailto:${CONTACT_EMAIL}`}>Contattaci</a>
            <button onClick={() => navigate('/')}>Torna alla Home</button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
